import { connect } from 'react-redux'
import ResolvedByBot from './ResolvedByBot.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsResolvedByBot.chartType,
    granularity: state.analyticsResolvedByBot.granularity,
    dateRange: state.analyticsResolvedByBot.dateRange,
    customDateRange: state.analyticsResolvedByBot.customDateRange,
    channelNameToFilter: state.analyticsResolvedByBot.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.resolvedByBotChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.resolvedByBotChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.resolvedByBotMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.resolvedByBotChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.resolvedByBotChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResolvedByBot)
